import { Capacitor } from '@capacitor/core';

/**
 * PayPal subscription UI may run only outside the iOS/Android Capacitor shells (store policy).
 * Prefer {@link Capacitor.getPlatform} over {@link Capacitor.isNativePlatform} so desktop/mobile
 * browsers (Chrome, Safari, Firefox, …) always qualify as "web".
 */
export function isPayPalWebShell() {
  if (typeof window === 'undefined') return false;
  try {
    const p = String(Capacitor.getPlatform?.() || '').toLowerCase();
    if (p === 'ios' || p === 'android') return false;
    return true;
  } catch {
    return true;
  }
}
